var IresultsMaster =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 5);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Lib = function () {
    function Lib() {
        _classCallCheck(this, Lib);

        throw new TypeError('Lib must not be instantiated');
    }

    /**
     * Get a collection of Node's
     *
     * @param {String|NodeList|Node} element
     * @returns {Node[]}
     */


    _createClass(Lib, null, [{
        key: 'dom',
        value: function dom(element) {
            if (arguments.length > 1) {
                var remainingArguments = Array.prototype.slice.call(arguments, 1);

                return Lib.dom(element).concat(Lib.dom.apply(this, remainingArguments));
            }

            if (typeof element === 'undefined' || element === null) {
                return [];
            }
            if (typeof element === 'string') {
                return Lib.dom(document.querySelectorAll(element));
            }

            if (element && element.nodeType > 0) {
                /** @type {Node} element */
                return [element];
            }

            return Array.prototype.slice.call(element);
        }
    }, {
        key: 'map',


        /**
         * Apply the given callback to each element in the given collection
         *
         * @param {*[]|NodeList|Node[]} collection
         * @param {function} callback
         * @returns {*[]}
         */
        value: function map(collection, callback) {
            if (typeof callback !== 'function') {
                throw new TypeError('Argument callback must be a function');
            }

            return Array.prototype.map.call(collection, callback);
        }
    }, {
        key: 'flatMap',


        /**
         * Apply the given callback to each element in the given collection
         *
         * @param {*[]|NodeList|Node[]} collection
         * @param {function} callback
         * @returns {*[]}
         */
        value: function flatMap(collection, callback) {
            if (typeof callback !== 'function') {
                throw new TypeError('Argument callback must be a function');
            }

            var arrayPrototype = Array.prototype;

            return arrayPrototype.concat.apply([], arrayPrototype.map.call(collection, function (i) {
                return arrayPrototype.slice.call(callback(i));
            }));
        }
    }, {
        key: 'filter',


        /**
         * Filter the given collection
         * @param {Node[]|NodeList} collection
         * @param {function} [callback]
         * @returns {*}
         */
        value: function filter(collection) {
            var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            if (null === callback) {
                callback = function callback(item) {
                    return !!item;
                };
            }
            return Array.prototype.filter.call(collection, callback);
        }
    }, {
        key: 'addEventListener',


        /**
         * Add an event listener to all elements in the given collection
         *
         * @param {Node[]|NodeList} collection
         * @param {string} eventName
         * @param {function} callback
         */
        value: function addEventListener(collection, eventName, callback) {
            if (typeof eventName !== 'string') {
                throw new TypeError('Argument eventName must be a string');
            }
            if (typeof callback !== 'function') {
                throw new TypeError('Argument callback must be a function');
            }
            Lib.map(collection, function (elements) {
                Lib.dom(elements).forEach(function (element) {
                    element.addEventListener(eventName, function (event) {
                        callback(event, this);
                    });
                });
            });
        }
    }, {
        key: 'data',


        /**
         * Returns the data value
         *
         * @param {HTMLElement} element
         * @param {string} dataAttribute
         * @returns {*|string}
         */
        value: function data(element, dataAttribute) {
            return element.getAttribute('data-' + dataAttribute);
        }
    }]);

    return Lib;
}();

exports.default = Lib;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var ef = function ef() {};

var Logger = (typeof console === 'undefined' ? 'undefined' : _typeof(console)) === 'object' ? console : {};

if (!Logger.log) {
    Logger.log = ef;
}
if (!Logger.debug) {
    Logger.debug = ef;
}
if (!Logger.info) {
    Logger.info = ef;
}
if (!Logger.warn) {
    Logger.warn = ef;
}
if (!Logger.error) {
    Logger.error = ef;
}

exports.default = Logger;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ScrollTo = function () {
    function ScrollTo() {
        _classCallCheck(this, ScrollTo);
    }

    _createClass(ScrollTo, null, [{
        key: 'scrollToAnimated',

        /**
         * Scroll to the y-coordinate defined by input with an animation lasting duration
         *
         * @param {number|Element|string} input The element/y-coordinate to scroll to
         * @param {number} duration Animation duration in milliseconds
         * @param {number} [offset] Allows to adjust the concrete coordinate to scroll to
         */
        value: function scrollToAnimated(input, duration, offset) {
            if (isNaN(duration)) {
                throw new TypeError('Invalid duration');
            }

            if (typeof offset === 'undefined') {
                offset = 0;
            }

            if (typeof input === 'string') {
                ScrollTo.scrollToAnimated(document.querySelector(input), duration, offset);

                return;
            }
            if ((typeof input === 'undefined' ? 'undefined' : _typeof(input)) === 'object') {
                if (typeof input.getBoundingClientRect === 'undefined') {
                    throw new TypeError('Input element must implement the method getBoundingClientRect');
                }
                ScrollTo.scrollToAnimated(ScrollTo.getElementOffsetTop(input), duration, offset);

                return;
            }

            if (isNaN(input)) {
                throw new TypeError('Unexpected input');
            }

            var elementY = input + offset;

            var startingY = window.pageYOffset;
            var diff = elementY - startingY;
            var start = void 0;

            // Bootstrap our animation - it will get called right before next frame shall be rendered.
            var tick = function tick(timestamp) {
                if (!start) start = timestamp;
                // Elapsed milliseconds since start of scrolling.
                var time = timestamp - start;
                // Get percent of completion in range [0, 1].
                var percent = Math.min(time / duration, 1);

                window.scrollTo(0, startingY + diff * percent);

                // Proceed with animation as long as we wanted it to.
                if (time < duration) {
                    window.requestAnimationFrame(tick);
                }
            };
            window.requestAnimationFrame(tick);
        }

        /**
         * @param {HTMLElement} element
         * @return {number}
         */

    }, {
        key: 'getElementOffsetTop',
        value: function getElementOffsetTop(element) {
            var rect = element.getBoundingClientRect();
            var documentElement = document.documentElement;

            return rect.top + window.pageYOffset - documentElement.clientTop;
        }
    }]);

    return ScrollTo;
}();

exports.default = ScrollTo;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _DrawerHandle = __webpack_require__(4);

var _DrawerHandle2 = _interopRequireDefault(_DrawerHandle);

var _Lib = __webpack_require__(0);

var _Lib2 = _interopRequireDefault(_Lib);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Drawer = function () {
    /**
     * @param {HTMLElement} container
     * @constructor
     */
    function Drawer(container) {
        _classCallCheck(this, Drawer);

        this._container = container;
        this._isOpen = container.classList.contains('open');

        this._detectHandles(container);
    }

    /**
     * Toggles the drawer
     */


    _createClass(Drawer, [{
        key: "toggle",
        value: function toggle() {
            if (this._isOpen) {
                this.close();
            } else {
                this.open();
            }
        }

        /**
         * Shows the drawer content
         */

    }, {
        key: "open",
        value: function open() {
            this._container.classList.add('open');
            this._isOpen = true;
        }

        /**
         * Hides the drawer content
         */

    }, {
        key: "close",
        value: function close() {
            this._container.classList.remove('open');
            this._isOpen = false;
        }

        /**
         * Returns if the handle does NOT point to a real location
         *
         * @param {HTMLElement|HTMLLinkElement} handle
         * @return {boolean} Returns FALSE if the element points to a anchor or another page
         * @private
         */

    }, {
        key: "_isNotALink",
        value: function _isNotALink(handle) {
            var link = handle.tagName === 'A' ? handle : handle.parentNode.tagName === 'A' ? handle.parentNode : null;
            if (null === link) {
                return true;
            }

            return !(link.href && link.href.slice(-1) !== '#');
        }

        /**
         * @param {HTMLElement} container
         * @return {DrawerHandle[]}
         * @private
         */

    }, {
        key: "_detectHandles",
        value: function _detectHandles(container) {
            var onlyUnique = function onlyUnique(value, index, self) {
                return self.indexOf(value) === index;
            };

            var unique = [].concat(this._detectMainHandles(container), this._detectRemoteHandles(container)).filter(onlyUnique);

            var drawerInstance = this;

            return _Lib2.default.map(unique, function (handle) {
                return new _DrawerHandle2.default(handle, drawerInstance);
            });
        }

        /**
         * @param {HTMLElement} container
         * @return {DrawerHandle[]}
         * @private
         */

    }, {
        key: "_detectMainHandles",
        value: function _detectMainHandles(container) {
            // Filter out handles that point to a real location (e.g. a anchor, another page)
            return _Lib2.default.filter(container.querySelectorAll('.drawer-handle'), this._isNotALink);
        }

        /**
         * @param {HTMLElement} container
         * @return {DrawerHandle[]}
         * @private
         */

    }, {
        key: "_detectRemoteHandles",
        value: function _detectRemoteHandles(container) {
            var selector = '[data-drawer-handle="' + this._getContainerIdentifier(container) + '"]';

            return Array.prototype.slice.call(document.querySelectorAll(selector), 0);
        }

        /**
         * @param {HTMLElement} container
         * @return {string}
         * @private
         */

    }, {
        key: "_getContainerIdentifier",
        value: function _getContainerIdentifier(container) {
            var dataDrawer = container.getAttribute('data-drawer');

            return dataDrawer ? dataDrawer : container.id ? container.id : '';
        }
    }]);

    return Drawer;
}();

exports.default = Drawer;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Drawer = __webpack_require__(3);

var _Drawer2 = _interopRequireDefault(_Drawer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * A button to show/hide the drawer
 */
var DrawerHandle = function () {
    /**
     * A button to show/hide the drawer
     *
     * @param {HTMLElement} element
     * @param {Drawer} drawer
     * @constructor
     */
    function DrawerHandle(element, drawer) {
        _classCallCheck(this, DrawerHandle);

        if (!(drawer instanceof _Drawer2.default)) {
            throw new TypeError('Argument "drawer" must be an instance of "Drawer"');
        }
        var _click = this.click = this.click.bind(this);
        this._drawer = drawer;

        element.addEventListener('click', _click);
    }

    _createClass(DrawerHandle, [{
        key: 'click',
        value: function click(event) {
            event.preventDefault();
            this._drawer.toggle();
        }
    }]);

    return DrawerHandle;
}();

exports.default = DrawerHandle;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Ui = exports.TranslationUtility = exports.ScrollTo = exports.Lib = exports.Logger = undefined;

var _Logger = __webpack_require__(1);

Object.defineProperty(exports, "Logger", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Logger).default;
  }
});

var _Lib = __webpack_require__(0);

Object.defineProperty(exports, "Lib", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Lib).default;
  }
});

var _ScrollTo = __webpack_require__(2);

Object.defineProperty(exports, "ScrollTo", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ScrollTo).default;
  }
});

var _TranslationUtility = __webpack_require__(6);

Object.defineProperty(exports, "TranslationUtility", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_TranslationUtility).default;
  }
});

var _Ui = __webpack_require__(7);

Object.defineProperty(exports, "Ui", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Ui).default;
  }
});

__webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TranslationUtility = function () {
    /**
     * @param {*} map A dictionary of translation keys to the translated texts
     */
    function TranslationUtility(map) {
        _classCallCheck(this, TranslationUtility);

        this._translationMap = map;
        this._language = document.documentElement.lang.toLowerCase();
    }

    /**
     * Returns the language to use
     *
     * @returns {string}
     */


    _createClass(TranslationUtility, [{
        key: 'translate',


        /**
         * Returns the translation for the given key
         *
         * @param {string} key
         * @param {*} variables
         * @returns {string}
         */
        value: function translate(key) {
            if (typeof key !== 'string') {
                throw new TypeError('Argument "key" must be of type string');
            }

            for (var _len = arguments.length, variables = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                variables[_key - 1] = arguments[_key];
            }

            return this._replaceParts(this._getTranslation(key), variables);
        }

        /**
         * @param {string} key
         * @return {string}
         * @private
         */

    }, {
        key: '_getTranslation',
        value: function _getTranslation(key) {
            return this._translationMap[key] || '';
        }

        /**
         * @param {string} format
         * @param {*[]} variables
         * @return {string}
         * @private
         */

    }, {
        key: '_replaceParts',
        value: function _replaceParts(format, variables) {
            var current = variables.shift();
            var output = format.replace(/%s/, '' + current);

            if (variables.length > 0) {
                return this._replaceParts(output, variables);
            }

            return '' + output;
        }
    }, {
        key: 'language',
        get: function get() {
            return this._language;
        }
    }]);

    return TranslationUtility;
}();

exports.default = TranslationUtility;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Drawer = __webpack_require__(3);

var _Drawer2 = _interopRequireDefault(_Drawer);

var _DrawerHandle = __webpack_require__(4);

var _DrawerHandle2 = _interopRequireDefault(_DrawerHandle);

var _OffCanvas = __webpack_require__(8);

var _OffCanvas2 = _interopRequireDefault(_OffCanvas);

var _SnapNavigation = __webpack_require__(9);

var _SnapNavigation2 = _interopRequireDefault(_SnapNavigation);

var _MobileNavigationToggle = __webpack_require__(10);

var _MobileNavigationToggle2 = _interopRequireDefault(_MobileNavigationToggle);

var _DetachNavbar = __webpack_require__(11);

var _DetachNavbar2 = _interopRequireDefault(_DetachNavbar);

var _SlowLink = __webpack_require__(12);

var _SlowLink2 = _interopRequireDefault(_SlowLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    DetachNavbar: _DetachNavbar2.default,
    Drawer: _Drawer2.default,
    DrawerHandle: _DrawerHandle2.default,
    OffCanvas: _OffCanvas2.default,
    SnapNavigation: _SnapNavigation2.default,
    SlowLink: _SlowLink2.default,
    MobileNavigationToggle: _MobileNavigationToggle2.default
};

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _Logger = __webpack_require__(1);

var _Logger2 = _interopRequireDefault(_Logger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @param {string|Element} element
 * @return {Element}
 */
var domElement = function domElement(element) {
    if (typeof element === 'string') {
        return document.querySelector(element);
    }
    if ((typeof element === 'undefined' ? 'undefined' : _typeof(element)) === 'object' && element.nodeType > 0) {
        return element;
    }
    throw new TypeError('Excepted argument "element" to be of type Element or string, got ' + (typeof element === 'undefined' ? 'undefined' : _typeof(element)));
};

var OffCanvas = function () {
    /**
     * Create a new Off-Canvas navigation
     *
     * @param {string|Element|null} showLeftButton
     * @param {string|Element|null} showRightButton
     * @param {string|Element|null} mainPage
     * @param {string|Element|null} container
     */
    function OffCanvas(showLeftButton, showRightButton, mainPage, container) {
        _classCallCheck(this, OffCanvas);

        this._bindMethods();

        this._container = container ? domElement(container) : document.getElementsByTagName('html')[0];
        this._mainPage = domElement(mainPage);
        this._visiblePage = 'main';

        this._addEventListeners(showLeftButton ? domElement(showLeftButton) : null, showRightButton ? domElement(showRightButton) : null, domElement('.show-main-page'));
    }

    _createClass(OffCanvas, [{
        key: 'getVisiblePage',


        /**
         * Returns the current visible page
         *
         * @returns {string}
         */
        value: function getVisiblePage() {
            return this._visiblePage;
        }

        /**
         * Sets the visible page
         *
         * @param {string} page
         * @returns {OffCanvas}
         */

    }, {
        key: 'setVisiblePage',
        value: function setVisiblePage(page) {
            page = '' + page;

            var container = this._container;

            if (this._visiblePage === page) {
                _Logger2.default.log('[Iresults.OffCanvas] ' + 'Page did not change');

                return this;
            }

            this._visiblePage = page;
            switch (page) {
                case 'left':
                case 'navigation':
                    _Logger2.default.log('[Iresults.OffCanvas] ' + 'Show mobile navigation');
                    this._registerMainPageClick();

                    container.classList.add('show-left-page');
                    container.classList.remove('show-right-page');
                    break;

                case 'right':
                case 'search':
                    _Logger2.default.log('[Iresults.OffCanvas] ' + 'Show mobile search');
                    this._registerMainPageClick();
                    container.classList.add('show-right-page');
                    container.classList.remove('show-left-page');
                    break;

                default:
                    _Logger2.default.log('[Iresults.OffCanvas] ' + 'Show main');
                    this._unregisterMainPageClick();
                    container.classList.remove('show-left-page');
                    container.classList.remove('show-right-page');
            }

            return this;
        }

        /**
         * Show the left page
         *
         * @returns {OffCanvas}
         */

    }, {
        key: 'showLeftPage',
        value: function showLeftPage() {
            this.visiblePage = 'left';

            return this;
        }

        /**
         * Show the right page
         *
         * @returns {OffCanvas}
         */

    }, {
        key: 'showRightPage',
        value: function showRightPage() {
            this.visiblePage = 'right';

            return this;
        }

        /**
         * Show the main page
         *
         * @returns {OffCanvas}
         */

    }, {
        key: 'showMainPage',
        value: function showMainPage() {
            this.visiblePage = 'main';

            return this;
        }

        /**
         * @private
         */

    }, {
        key: '_addEventListeners',
        value: function _addEventListeners(showLeftButton, showRightButton, showMainButton) {
            if (showLeftButton) {
                _Logger2.default.debug('[Iresults.OffCanvas] ' + 'Add click event listener to showLeftButton', showLeftButton);
                showLeftButton.addEventListener('click', this._showLeftPageCallback);
            }
            if (showRightButton) {
                _Logger2.default.debug('[Iresults.OffCanvas] ' + 'Add click event listener to showRightButton', showRightButton);
                showRightButton.addEventListener('click', this._showRightPageCallback);
            }
            if (showMainButton) {
                _Logger2.default.debug('[Iresults.OffCanvas] ' + 'Add click event listener to showMainButton', showMainButton);
                showMainButton.addEventListener('click', this._showMainPageCallback);
            }
        }

        /**
         * @private
         */

    }, {
        key: '_registerMainPageClick',
        value: function _registerMainPageClick() {
            this._mainPage.addEventListener('mousedown', this._showMainPageCallback);
        }

        /**
         * @private
         */

    }, {
        key: '_unregisterMainPageClick',
        value: function _unregisterMainPageClick() {
            this._mainPage.removeEventListener('mousedown', this._showMainPageCallback);
        }

        /**
         * @private
         */

    }, {
        key: '_showLeftPageCallback',
        value: function _showLeftPageCallback(event) {
            _Logger2.default.debug('[Iresults.OffCanvas] ' + 'Show left page button clicked');
            event.stopPropagation();
            this.showLeftPage();
        }

        /**
         * @private
         */

    }, {
        key: '_showRightPageCallback',
        value: function _showRightPageCallback(event) {
            _Logger2.default.debug('[Iresults.OffCanvas] ' + 'Show right page button clicked');
            event.stopPropagation();
            this.showRightPage();
        }

        /**
         * @private
         */

    }, {
        key: '_showMainPageCallback',
        value: function _showMainPageCallback(event) {
            _Logger2.default.debug('[Iresults.OffCanvas] ' + 'Show main page button clicked');
            if (this.visiblePage !== 'main') {
                event.stopPropagation();
                this.showMainPage();
            }
        }

        /**
         * @private
         */

    }, {
        key: '_bindMethods',
        value: function _bindMethods() {
            this._showMainPageCallback = this._showMainPageCallback.bind(this);
            this._showLeftPageCallback = this._showLeftPageCallback.bind(this);
            this._showRightPageCallback = this._showRightPageCallback.bind(this);
        }
    }, {
        key: 'visiblePage',
        set: function set(newValue) {
            this.setVisiblePage(newValue);
        },
        get: function get() {
            return this.getVisiblePage();
        }
    }]);

    return OffCanvas;
}();

exports.default = OffCanvas;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* jshint strict: true */
/* globals exports, jQuery */

/**
 * JavaScript version of "position: sticky"
 */
var SnapNavigation = function () {
    function SnapNavigation(element) {
        _classCallCheck(this, SnapNavigation);

        this.scroll = this.scroll.bind(this);
        this.docked = false;
        this._element = jQuery(element);
        this._initValue = -1;
        this.isNavbar = this._element.hasClass('navbar');

        this._initialize();
    }

    /**
     * @private
     */


    _createClass(SnapNavigation, [{
        key: '_initialize',
        value: function _initialize() {
            var snapBreakpoint = this._element.data('snap-breakpoint');
            if (snapBreakpoint && jQuery(window).width() < parseInt(snapBreakpoint)) {
                return;
            }

            jQuery(window).scroll(this.scroll);
            window.setTimeout(this.scroll, 500);
        }

        /**
         * On-scroll callback
         */

    }, {
        key: 'scroll',
        value: function scroll() {
            var menu = this._element;

            if (!this.docked && menu.offset().top - this.scrollTop() < 0) {
                // Dock it
                if (this._initValue === -1) {
                    this._initValue = menu.offset().top;
                }

                if (this.isNavbar) {
                    menu.addClass('navbar-fixed-top');
                } else {
                    menu.css('top', 0).css('position', 'fixed').addClass('docked');
                }
                this.docked = true;
            } else if (this.docked && this.scrollTop() <= this._initValue) {
                // Undock it
                if (this.isNavbar) {
                    menu.removeClass('navbar-fixed-top');
                } else {
                    menu.css('position', 'static').removeClass('docked');
                }
                this.docked = false;
            }
        }

        /**
         * Returns the scroll top
         *
         * @return {number}
         */

    }, {
        key: 'scrollTop',
        value: function scrollTop() {
            return document.body.scrollTop || document.documentElement.scrollTop;
        }
    }]);

    return SnapNavigation;
}();

exports.default = SnapNavigation;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Lib = __webpack_require__(0);

var _Lib2 = _interopRequireDefault(_Lib);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @param {HTMLElement} element
 * @return {boolean}
 */
var elementIsVisible = function elementIsVisible(element) {
    return element.offsetWidth > 0 || element.offsetHeight > 0;
};

/**
 * @param {*[]|NodeList} collection
 * @param {function} callback
 * @return {*}
 */
var map = _Lib2.default.map;

/**
 * Toggle deeper levels of the mobile navigation
 */

var MobileNavigationToggle = function () {
    /**
     * @param {HTMLElement} navigation Navigation element
     */
    function MobileNavigationToggle(navigation) {
        _classCallCheck(this, MobileNavigationToggle);

        var _click = this.click = this.click.bind(this);
        this._navigation = navigation;

        map(navigation.querySelectorAll('li,.li,.nav-menu-item'), function (element) {
            element.addEventListener('click', _click);
        });
    }

    /**
     * @param {MouseEvent} event
     */


    _createClass(MobileNavigationToggle, [{
        key: 'click',
        value: function click(event) {
            /** @type {HTMLElement|EventTarget} */
            var clickedElement = event.target;
            /** @type {HTMLElement|EventTarget} */
            var listeningElement = event.currentTarget;

            /*
             * If the clicked element is not a link (or child of a link) and the navbar-toggle button is visible
             * toggle the class and stop to event from bubbling up
             */
            if (this._isCollapsed() && !this._isLinkChild(clickedElement, this._navigation)) {
                this._toggleClass(listeningElement, 'on');
                event.preventDefault();
                event.stopPropagation();
            }
        }
    }, {
        key: '_isCollapsed',
        value: function _isCollapsed() {
            var navbarToggle = document.querySelector('.navbar-toggle');
            if (navbarToggle) {
                return elementIsVisible(navbarToggle);
            }

            return window.matchMedia && window.matchMedia("only screen and (max-width: 767px)").matches;
        }

        /**
         * @param {HTMLElement} element
         * @param {string} className
         * @private
         */

    }, {
        key: '_toggleClass',
        value: function _toggleClass(element, className) {
            var classList = element.classList;
            if (classList.contains(className)) {
                classList.remove(className);
            } else {
                classList.add(className);
            }
        }

        /**
         * @param {Node|HTMLElement} element
         * @return {boolean}
         * @private
         */

    }, {
        key: '_isLink',
        value: function _isLink(element) {
            return ['A', 'BUTTON', 'INPUT'].indexOf(element.tagName) !== -1 || element.getAttribute && element.getAttribute('href');
        }

        /**
         * @param {Node} element
         * @param {Node} [stop]
         * @return {boolean}
         * @private
         */

    }, {
        key: '_isLinkChild',
        value: function _isLinkChild(element, stop) {
            if (this._isLink(element)) {
                return true;
            }

            var parent = element.parentNode;
            if (!parent || parent === document || stop && parent === stop) {
                return false;
            }

            return this._isLinkChild(parent, stop);
        }
    }]);

    return MobileNavigationToggle;
}();

exports.default = MobileNavigationToggle;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Plugin to mark the navbar as attached if the window is not scrolled,
 * or as _detached otherwise
 */
var DetachNavbar = function () {
    function DetachNavbar(navbar) {
        var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

        _classCallCheck(this, DetachNavbar);

        if (typeof jQuery === 'undefined') {
            throw new ReferenceError('jQuery is required');
        }
        var scroll = this.scroll = this.scroll.bind(this);
        this.navbar = jQuery(navbar);
        this.offset = offset;
        this._detached = undefined;

        jQuery(window).scroll(scroll);

        // Init
        scroll();
    }

    _createClass(DetachNavbar, [{
        key: 'scroll',
        value: function scroll() {
            var _detached = this._detached;
            if (jQuery(window).scrollTop() <= this.offset) {
                if (_detached !== false) {
                    this._detached = false;
                    this.navbar.addClass('attached').removeClass('detached');
                }
            } else if (_detached !== true) {
                this.navbar.addClass('detached').removeClass('attached');
                this._detached = true;
            }
        }
    }, {
        key: 'detached',
        get: function get() {
            return this._detached;
        }
    }]);

    return DetachNavbar;
}();

exports.default = DetachNavbar;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Lib = __webpack_require__(0);

var _Lib2 = _interopRequireDefault(_Lib);

var _ScrollTo = __webpack_require__(2);

var _ScrollTo2 = _interopRequireDefault(_ScrollTo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Object representation of an URL
 */
var Url = function () {
    /**
     * Object representation of an URL
     *
     * @param {string} href
     * @constructor
     */
    function Url(href) {
        _classCallCheck(this, Url);

        if (arguments.length > 0) {
            var location = typeof window !== 'undefined' ? window.location : {};
            var parser = document.createElement('a');
            parser.href = this._prepareDoubleStash('' + href);

            this._protocol = parser.protocol && parser.protocol !== ':' ? parser.protocol : location.protocol; // => "http:"
            this._port = parser.port || location.port; // => "3000"
            this._hostname = parser.hostname || location.hostname; // => "example.com"
            this._host = parser.host || (this._port ? this._hostname + ':' + this._port : this._hostname); // => "example.com:3000"
            this._setPathname(parser.pathname || location.pathname); // => "/pathname/"
            this._setHash(parser.hash); // => "#hash"
            this._setSearch(parser.search); // => "?search=test"
        } else {
            this._protocol = '';
            this._host = '';
            this._hostname = '';
            this._port = '';
            this._hash = '';
            this._search = '';
            this._setPathname('');
        }
    }

    /**
     * Returns a string representation of the URL object
     *
     * @return {string}
     */


    _createClass(Url, [{
        key: "toString",
        value: function toString() {
            return (this._protocol ? this._protocol + '//' : '') + this._host + this._pathname + this._search + this._hash;
        }

        /**
         * Returns the hash
         *
         * @return {string}
         */

    }, {
        key: "_prepareDoubleStash",


        /**
         * Adds the protocol if the URI starts with //
         *
         * @param {string} input
         * @returns String}
         * @private
         */
        value: function _prepareDoubleStash(input) {
            if (input.substr(0, 2) === '//') {
                if (typeof window !== 'undefined') {
                    return window.location.protocol + input;
                }
                return 'http:' + input;
            }
            return input;
        }

        /**
         * Sets the pathname
         *
         * @param {string} newValue
         * @private
         */

    }, {
        key: "_setPathname",
        value: function _setPathname(newValue) {
            newValue = '' + newValue;
            if (!newValue || newValue[0] !== '/') {
                newValue = '/' + newValue;
            }
            this._pathname = newValue;
        }

        /**
         * Sets the hash
         *
         * @param {string} newValue
         * @private
         */

    }, {
        key: "_setHash",
        value: function _setHash(newValue) {
            newValue = '' + newValue;
            if (newValue && newValue.charAt(0) !== '#') {
                newValue = '#' + newValue;
            }
            this._hash = newValue;
        }

        /**
         * Sets the search
         *
         * @param {string} newValue
         * @private
         */

    }, {
        key: "_setSearch",
        value: function _setSearch(newValue) {
            newValue = '' + newValue;
            if (newValue && newValue[0] !== '?') {
                newValue = '?' + newValue;
            }
            this._search = newValue;
        }
    }, {
        key: "hash",
        get: function get() {
            return this._hash;
        }
    }]);

    return Url;
}();

/**
 * Add a scroll-to animation to anchor links
 */


var SlowLink = function () {
    /**
     * @param {HTMLElement[]|Node[]|NodeList} links
     * @param {object} options
     */
    function SlowLink(links) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        _classCallCheck(this, SlowLink);

        this._options = options;
        _Lib2.default.addEventListener(links, 'click', this.click.bind(this));
    }

    /**
     * @param {Url} uri
     * @private
     */


    _createClass(SlowLink, [{
        key: "_updateLocation",
        value: function _updateLocation(uri) {
            var stateObj = { uri: uri.toString() };
            history.pushState(stateObj, "Link", uri.toString());
        }

        /**
         * Handle the click on a slow link
         *
         * @param {MouseEvent} event
         * @param {HTMLElement} link
         */

    }, {
        key: "click",
        value: function click(event, link) {
            event.preventDefault();
            var duration = parseInt(_Lib2.default.data(link, 'slow-link') || this._options.duration || 500, 10);
            var uri = new Url(link.getAttribute('href'));
            var target = SlowLink.getTargetElementForUri(uri);
            var offset = parseInt(_Lib2.default.data(link, 'slow-link-offset') || this._options.offset || 0, 10);
            if (target) {
                _ScrollTo2.default.scrollToAnimated(target, duration, offset);
                this._updateLocation(uri);
            }
        }

        /**
         * @param {Url} uri
         * @return {Element|null}
         */

    }], [{
        key: "getTargetElementForUri",
        value: function getTargetElementForUri(uri) {
            try {
                return uri.hash ? document.querySelector(uri.hash) : null;
            } catch (e) {}

            return null;
        }
    }]);

    return SlowLink;
}();

exports.default = SlowLink;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
if (typeof Object.assign != 'function') {
    Object.assign = function (target, varArgs) {
        // .length of function is 2
        'use strict';

        if (target == null) {
            // TypeError if undefined or null
            throw new TypeError('Cannot convert undefined or null to object');
        }

        var to = Object(target);

        for (var index = 1; index < arguments.length; index++) {
            var nextSource = arguments[index];

            if (nextSource != null) {
                // Skip over if undefined or null
                for (var nextKey in nextSource) {
                    // Avoid bugs when hasOwnProperty is shadowed
                    if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                        to[nextKey] = nextSource[nextKey];
                    }
                }
            }
        }
        return to;
    };
}

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// iresults_master.js